var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',[_vm._v("Recepción rayos X")]),_c('v-text-field',{attrs:{"label":"Paciente"},model:{value:(_vm.paciente),callback:function ($$v) {_vm.paciente=$$v},expression:"paciente"}}),_c('v-btn',{attrs:{"color":"success"},on:{"click":_vm.registrar}},[_vm._v(" Registrar ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }